import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards, { ServiceCardItem } from "@/components/service/ServiceCards";
import LandscapingQuote from "./sections/LandscapingQuote";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { LayoutGrid, Droplets, Route, Leaf, Square, Fence } from "lucide-react";
const subServices: ServiceCardItem[] = [{
  title: "Block Paving",
  description: "Durable and visually appealing block paving solutions for driveways and pathways, offering a wide range of patterns and colours.",
  icon: LayoutGrid,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/service_block_paving.png",
  imageAlt: "Block paving installation in Southampton",
  to: "/BlockPavingPage"
}, {
  title: "Resinbound",
  description: "Smooth, permeable, and highly durable resinbound surfaces, perfect for modern driveways with a flawless, weed-free finish.",
  icon: Droplets,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/service_resinbound.png",
  imageAlt: "Resinbound driveway laid in Southampton",
  to: "/ResinboundPage"
}, {
  title: "Tarmac",
  description: "Cost-effective and resilient tarmac laying for driveways and commercial spaces, ensuring a long-lasting, smooth surface.",
  icon: Route,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/service_tarmac.png",
  imageAlt: "Tarmac driveway surfacing in Southampton",
  to: "/TarmacServicesPage"
}, {
  title: "Turfing & Artificial Grass",
  description: "Lush, green lawns installed with premium natural turf or low-maintenance, high-quality artificial grass options.",
  icon: Leaf,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/service_turfing.png",
  imageAlt: "Turfing and artificial lawn installation in Southampton",
  to: "/TurfingArtificialGrassServicesPage"
}, {
  title: "Patios",
  description: "Beautifully designed patios using natural stone, porcelain, or concrete slabs to create your perfect outdoor living space.",
  icon: Square,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/service_patios.png",
  imageAlt: "Natural stone patio design in Southampton",
  to: "/PatiosPage"
}, {
  title: "Fencing",
  description: "Secure and stylish fencing installations, including timber panels, closeboard, and decorative options to enhance privacy.",
  icon: Fence,
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/service_fencing.png",
  imageAlt: "Timber fencing installation in Southampton",
  to: "/FencingPage"
}];
export default function PremiumLandscapingServicesPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Landscaping" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Landscaping in Southampton" intro="Transforming outdoor spaces with bespoke patios, block paving, and lush turfing or artificial grass for homeowners across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/landscaped_garden_patio_hero.png" imageAlt="Beautiful landscaped garden and patio completed in Southampton by Firststop Roofing Ltd" actions={true} />

      <ServiceIntro eyebrow="EXPERT CRAFTSMANSHIP" heading="Professional Landscaping & Garden Transformations in Southampton" paragraphs={["Looking for expert garden landscaping in Southampton? Firststop Roofing Ltd delivers complete outdoor transformations, combining durable hard landscaping, precision groundworks, and pristine lawn installations built to withstand British weather and look stunning year-round.", "From custom natural stone patios and permeable driveways to low-maintenance artificial turf and secure boundary fencing, our Southampton landscaping specialists take pride in delivering neat, enduring workmanship with honest advice from start to finish."]} benefits={["Bespoke patio, driveway, and garden design tailored to Southampton properties", "High-grade natural stone, paving, and turfing materials installed with precision", "Respectful scheduling, transparent milestones, and free no-obligation quotations"]} imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/landscaping-work.jpg?v=aojm8cj0olo" imageAlt="Garden landscaping and patio construction work completed in Southampton by Firststop Roofing Ltd" cta={true} />

      <ServiceCards eyebrow="SPECIALIST SOLUTIONS" heading="Our Southampton Landscaping Services" intro="High-quality hard and soft landscaping solutions tailored to transform gardens and driveways across Southampton, Hampshire & surrounding areas." items={subServices} columns={3} />

      <LandscapingQuote />

      <OtherServices currentKey="landscaping" />

      <CtaBand />

      <Footer />
    </div>;
}